import { APIContext, APIProvider } from './api';

class KContext {
  static APIProvider = APIProvider;
  static APIContext = APIContext;
}

export { KContext };
